import { useBenchmark } from "@/contexts/BenchmarkContext";
import { useEffect, useState, type PropsWithChildren } from "react";
const BENCHMARK_MODE = import.meta.env.VITE_BENCHMARK_MODE === 'true';
export const Container = ({ children }: PropsWithChildren) => {

    return (
        <div className="flex flex-col overflow-auto h-screen lg:flex-row lg:justify-center">
            <div className="flex-1">
                {children}
            </div>
            {
                BENCHMARK_MODE &&
                // <div className="flex flex-col min-h-0 w-full lg:w-1/2 border border-1 border-blue-500 text-white p-2">
                <div className="border border-1 border-blue-500 flex flex-col text-white w-full lg:w-1/2 lg:min-w-1/2 lg:overflow-auto">
                    <div className="flex justify-between min-h-0">
                        <BenchmarkHeader />
                    </div>
                    <ScanResultsDisplay />
                    <div className="min-h-0">
                        <h3 className="font-semibold mb-2">Benchmark Entries</h3>
                        <table className="w-full table-auto text-sm">
                            <thead>
                                <tr className="border-b border-gray-700">
                                    <th className="p-2 text-left">Name</th>
                                    <th className="p-2 text-left">Duration (ms)</th>
                                    <th className="p-2 text-left">Timestamp</th>
                                </tr>
                            </thead>
                            <tbody>
                                <BenchmarkEntries />
                            </tbody>
                        </table>
                    </div>
                </div>
            }
        </div>
    )
}

const ScanResultsDisplay = () => {

    const { scanResults } = useBenchmark();
    const thStyle = "font-bold text-left w-1/3 pr-2 border border-gray-700";
    const tdStyle = "border border-gray-700 w-2/3 text-gray-400";
    return (
        <div className="min-h-0">
            <h3 className="font-semibold mb-2">Scan Results</h3>
            <table className="w-full table-auto text-sm mb-4 border border-gray-700">
                <tbody>
                    <tr>
                        <th className={thStyle}>QR One:</th>
                        <td className={tdStyle}>{scanResults.qrOne}</td>
                    </tr>
                    <tr>
                        <th className={thStyle}>QR Two:</th>
                        <td className={tdStyle}>{scanResults.qrTwo}</td>
                    </tr>
                    <tr>
                        <th className={thStyle}>Serial Code:</th>
                        <td className={tdStyle}>{scanResults.serial}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

const BenchmarkHeader = () => {
    const { startTime, getElapsedTimeMs } = useBenchmark();
    const [elapsedTime, setElapsedTime] = useState<number>(0);

    useEffect(() => {
        if (!startTime) return;
        const interval = setInterval(() => {
            setElapsedTime(getElapsedTimeMs());
        }, 1000); // update every second
        return () => clearInterval(interval);
    }, [startTime, getElapsedTimeMs]);

    const { entries } = useBenchmark();
    return (
        <div className="flex flex-col lg:flex-row justify-between mb-2">
            <h2 className="font-bold">Benchmark Results ({entries.length} entries)</h2>
            <h2 className="font-bold">Total Elapsed Time: {elapsedTime} ms </h2>
        </div>
    )
}

const BenchmarkEntries = () => {
    const { entries } = useBenchmark();
    return (
        <>
            {entries.map((entry, index) => (
                <tr key={index} className="border-b border-gray-700">
                    <td className="p-2">{entry.name}</td>
                    <td className="p-2">{entry.durationMs}</td>
                    <td className="p-2">{new Date(entry.timestamp).toLocaleTimeString()}</td>
                </tr>
            ))}
        </>

    )
}